import React from 'react';

export const FRAME_ID = 'shareFrameContainer';
export const TeamsFrame = ({ frameUrl }) => (
  <div id={FRAME_ID} data-src={frameUrl}></div>
);
